import { useEffect } from "react";
import { Navigation } from "../components/Navigation";
import { Hero } from "../components/Hero";
import { MarqueeBand } from "../components/MarqueeBand";
import { SpeciesCatalog } from "../components/SpeciesCatalog";
import { SpeciesCompare } from "../components/SpeciesCompare";
import { GradeGuide } from "../components/GradeGuide";
import { Manifesto } from "../components/Manifesto";
import { GlobalReach } from "../components/GlobalReach";
import { ExportMap } from "../components/ExportMap";
import { LoadCalculator } from "../components/LoadCalculator";
import { QuoteForm } from "../components/QuoteForm";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { scrollToSection } from "../components/SmoothScroll";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => scrollToSection(id), 450);
    }
  }, []);

  return (
    <>
      <Seo
        title="7 Seas Group USA — Premium U.S. & Canadian Lumber Exporters"
        description="Family-owned lumber exporter since 2007. Premium U.S. & Canadian hardwoods and softwoods — White Oak, Walnut, Maple, Cedar & more — graded, kiln-dried and shipped to 40+ countries."
        image="/species/white-oak-1.jpg"
      />
      <Navigation />
      <main>
        <Hero />
        <MarqueeBand />
        <SpeciesCatalog />
        <SpeciesCompare />
        <GradeGuide />
        <Manifesto />
        <GlobalReach />
        <ExportMap />
        <LoadCalculator />
        <QuoteForm />
      </main>
      <Footer />
    </>
  );
}
